import { integerType } from "../../../data/main";
import { stdObject } from "../../../data/types/stdObject";

export const inputIssuesType = (code: number, data: stdObject) => {
  switch (code) {
    case 0:
      return { type: "checkbox" };
    case 1:
      return { type: "number" };
    case 3:
      return { type: "textarea" };
    case 4:
      return {
        type: "select",
        options: data.SELSDA.split(",").map((e: string, index: number) => {
          return { label: e, value: index };
        }),
      };
    case 5: // drawing
      return { type: "text" };
    case integerType:
      return { type: "integer" };
    case 7:
      return { type: "date" };
    default:
      return { type: "text" };
  }
};
